<template>
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25 7L7 25" stroke="red" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M25 25L7 7" stroke="red" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</template>